var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMogul(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\t.MogulLogoSignNoColor01{filter:url(#mogulLogoSignNoColorOpacityMaskFilter);}\r\n\t\t.MogulLogoSignNoColor02{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t\t.MogulLogoSignNoColor03{mask:url(#mogulLogoSignNoColorMogulLogoSignId01);fill-rule:evenodd;clip-rule:evenodd;}\r\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MogulLogoSignNoColor00",
    d: "M23,0.4l-7,6.9L9,0.4H0l0,0v31.5h0l15-14.8l-4.5-4.4l-4.2,4.1V6.7l5.2,5.1l0,0l4.5,4.4l0,0l0,0l4.5-4.4l0,0 l5.2-5.1v10.2l-4.2-4.2L17,17.2l8.7,8.6v0L32,32h0V0.4H23z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(633.000000, 93.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "mogulLogoSignNoColorOpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: -689,
    y: -93,
    width: 32,
    height: 32
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: -689,
    y: -93,
    width: 32,
    height: 32,
    id: "mogulLogoSignNoColorMogulLogoSignId01"
  }, /*#__PURE__*/React.createElement("g", {
    className: "MogulLog0ignSt1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "MogulLogoSignNoColor02",
    points: "-666,-93 -673,-85.9 -680,-93 -689,-93 -689,-92.9 -689,-61 -688.9,-61 -674,-76 -678.5,-80.5 -682.6,-76.3 -682.6,-86.6 -677.5,-81.5 -677.5,-81.4 -673,-77 -673,-77 -673,-77 -668.5,-81.4 -668.5,-81.5  -663.3,-86.6 -663.3,-76.3 -667.5,-80.5 -672,-76 -663.3,-67.3 -663.3,-67.3 -657,-61 -657,-61 -657,-93"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "MogulLogoSignNoColor03",
    points: "-666,-93 -673,-85.9 -680,-93 -689,-93 -689,-92.9 -689,-61 -688.9,-61 -674,-76 -678.5,-80.5 -682.6,-76.3 -682.6,-86.6 -677.5,-81.5 -677.5,-81.4 -673,-77 -673,-77 -673,-77 -668.5,-81.4 -668.5,-81.5 -663.3,-86.6 -663.3,-76.3 -667.5,-80.5 -672,-76 -663.3,-67.3 -663.3,-67.3 -657,-61 -657,-61 -657,-93"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMogul);
export default __webpack_public_path__ + "static/media/logo-mogul.2ef7cc5cd68ce0626e036929c41e67be.svg";
export { ForwardRef as ReactComponent };